"use client";

import React, { useEffect, useState } from "react";
import { useAppSelector } from "@/redux/hooks";
import signedInStateSelector from "@/redux/slice/auth/selectors/signedInState";
import { SignedinState } from "@/redux/slice/auth/enums/SignedInState";
import SideBar from "./SideBar";
import HamburgerInfo from "./HamburgerInfo";
import { HamburgerData } from "./interface";

interface HamburgerMenuModalProps {
  handleOpen: (open: boolean) => void;
  open: boolean;
  hamburgerPanelData?: HamburgerData[];
  loginCta?: (() => void) | null;
  userName?: string;
  logoutCta?: () => void;
}

const HamburgerMenuModal: React.FC<HamburgerMenuModalProps> = ({
  handleOpen,
  open,
  hamburgerPanelData,
  loginCta,
  userName,
  logoutCta,
}) => {
  const signedInStatus = useAppSelector(signedInStateSelector);
  const [showInSSR, setShowInSSR] = useState<boolean>(true);
  const isLoggedIn = signedInStatus === SignedinState.SIGNEDIN;

  useEffect(() => {
    setShowInSSR(false);
  }, []);

  const handleLoginClick = () => {
    if (loginCta) {
      loginCta();
    }

    handleOpen(false);
  };

  const handleLogout = () => {
    if (logoutCta) {
      logoutCta();
    }
  };

  return (
    <SideBar
      isOpen={open}
      showInSSR={showInSSR}
      handleOpen={handleOpen}
      title={`Welcome ${userName || "User"}`}
      loginCta={loginCta ? handleLoginClick : null}
      isLoggedIn={isLoggedIn}
      logoutCta={handleLogout}
      isSideBarRightAlign={false}
    >
      {hamburgerPanelData &&
        hamburgerPanelData?.length > 0 &&
        hamburgerPanelData.map((data) => {
          return (
            <HamburgerInfo
              hamburgerData={data}
              handleOpen={handleOpen}
              key={`links_${data?.title}`}
              showInSSR={showInSSR}
            />
          );
        })}
    </SideBar>
  );
};

export default HamburgerMenuModal;
